import DateFormatResolver from 'resolvers/date-format.resolver';

export default (data = [], granularity) => {
	const goodCallsCounts = [];
	const labels = [];
	const dateFormat = granularity === 'hour' ? 'hA' : 'DD MMM `YY';
	for (let i = 0; i < data.length; i += 1) {
		goodCallsCounts.push(data[i].goodCallsCount);
		labels.push(DateFormatResolver.resolve(data[i].timeSlot, dateFormat));
	}
	const pointRadius = data.length > 50 ? 0 : 3;
	const borderWidth = data.length > 50 ? 1 : 3;

	return {
		data: {
			labels,
			datasets: [
				{
					label: 'Total',
					data: goodCallsCounts,
					fill: false,
					borderColor: '#5aaf4b',
					pointBackgroundColor: '#5aaf4b',
					pointRadius,
					borderWidth,
				},
			],
		},
		options: {
			plugins: {
				datalabels: {
					display: false,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						scaleShowGridLines: true,
						ticks: {
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						ticks: {
							stepSize: 1,
							min: 0,
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: true,
							drawBorder: false,
							borderDash: [2, 2],
							color: 'rgba(0, 0, 0, 0.2)',
						},
					},
				],
			},
		},
		type: 'line',
		hasData: labels.length > 0,
	};
};
